import {AccordionContext} from 'react-bootstrap';
import React, {type ReactNode} from 'react';
import {type AccordionContextValue} from 'react-bootstrap/AccordionContext';

export const AccordionContextConsumer = ({children}: {children: (value: AccordionContextValue) => ReactNode}) => {
    return <AccordionContext.Consumer>
        {children}
    </AccordionContext.Consumer>;
};
